import * as Sentry from "@sentry/browser";
import { EVENT_API_FAILURE, eventEmitter } from "@smp/utils";
export class FailureApi extends Error {
    constructor(code, payload, failures) {
        super(code);
        this.code = code;
        this.failures = failures;
        this.payload = payload;
        Object.setPrototypeOf(this, FailureApi.prototype);
    }
}
//
// hash
//
const errorToFailureHashRoot = {
    ABORT_ERROR: "API__ROOT__ABORT_ERROR",
    FETCH_INTERNAL: "API__ROOT__FETCH__NO__RESPONSE",
    ORGANIZATION_NOT_FOUND: "API__ROOT__ORGANIZATION_NOT_FOUND",
    ORGANIZATION_TEMPORARILY_INACTIVE: "API__ROOT__ORGANIZATION_TEMPORARILY_INACTIVE",
    TRANSFER_PAGE_CONFIG_ID_REQUIRED: "API__ROOT__TRANSFER_PAGE_CONFIG_ID_REQUIRED",
    TRANSFER_PAGE_CONFIG_INVALID: "API__ROOT__TRANSFER_PAGE_CONFIG_INVALID",
    UNKNOWN: "API__ROOT__UNKNOWN",
    VALIDATION_ERROR: "API__ROOT__VALIDATION_ERROR",
    RATE_LIMIT: "API__ROOT__RATE_LIMIT",
};
const errorToFailureHashValidation = {
    MAX_LENGTH: "API__ROOT__VALIDATION_ERROR__MAX_LENGTH",
};
//
// helpers
//
const captureApiException = (failureApi) => {
    const headers = failureApi.payload.response.headers;
    Sentry.withScope((scope) => {
        const body = headers.get("content-type") === "application/json"
            ? failureApi.payload.body
            : undefined;
        const requestId = headers.get("x-request-id");
        const traceId = headers.get("x-trace-id");
        body && scope.setExtra("body", body);
        requestId && scope.setExtra("x-request-id", requestId);
        traceId && scope.setExtra("x-trace-id", traceId);
        Sentry.captureException(failureApi);
    });
};
export const failureApiGenerator = (payload, errorToFailureHash) => {
    const failureCode = Object.assign(Object.assign({}, errorToFailureHashRoot), errorToFailureHash)[payload.body.error_type];
    const failureApi = failureCode
        ? failureCode === "API__ROOT__VALIDATION_ERROR" ||
            failureCode === "API__EP__BILLING__PROMOCODE_PRODUCT_INCOMPATIBLE"
            ? (() => {
                const extra = payload.body.extra;
                return new FailureApi(failureCode, payload, extra
                    ? Object.keys(extra).reduce((failures, extraKey) => {
                        if (extra[extraKey].error_type) {
                            const body = extra[extraKey];
                            const failure = failureApiGenerator({
                                body,
                                response: payload.response,
                            }, Object.assign(Object.assign({}, errorToFailureHash), errorToFailureHashValidation));
                            failures[extraKey] = failure;
                        }
                        return failures;
                    }, {})
                    : undefined);
            })()
            : new FailureApi(failureCode, payload)
        : (() => {
            if (failureCode === "API__ROOT__FETCH__NO__RESPONSE") {
                return new FailureApi(failureCode, payload);
            }
            const status = payload.response.status;
            const failureApi = new FailureApi(status === 504
                ? "API__INTERNAL__504_GATEWAY_TIMEOUT"
                : status === 503
                    ? "API__INTERNAL__503_SERVICE_UNAVAILABLE"
                    : status === 501
                        ? "API__INTERNAL__501_NOT_IMPLEMENTED"
                        : status === 502
                            ? "API__INTERNAL__502_BAD_GATEWAY"
                            : status === 501
                                ? "API__INTERNAL__501_NOT_IMPLEMENTED"
                                : status === 500
                                    ? "API__INTERNAL__500_INTERNAL_SERVER_ERROR"
                                    : status === 409
                                        ? "API__INTERNAL__409_CONFLICT"
                                        : status === 405
                                            ? "API__INTERNAL__405_METHOD_NOT_ALLOWED"
                                            : status === 404
                                                ? "API__INTERNAL__404_NOT_FOUND"
                                                : status === 403
                                                    ? "API__INTERNAL__403_FORBIDDEN"
                                                    : status === 401
                                                        ? "API__INTERNAL__401_UNAUTHORIZED"
                                                        : status === 400
                                                            ? "API__INTERNAL__400_BAD_REQUEST"
                                                            : status === 413
                                                                ? "API__INTERNAL__413_PAYLOAD_TOO_LARGE"
                                                                : status === 422
                                                                    ? "API__INTERNAL__422_UNPROCESSABLE_ENTITY"
                                                                    : "API__ROOT__UNKNOWN", payload);
            captureApiException(failureApi);
            return failureApi;
        })();
    eventEmitter.emit(EVENT_API_FAILURE, failureApi);
    return failureApi;
};
//# sourceMappingURL=failure.js.map